module.exports = __webpack_public_path__ + "img/img_term_tit.d1c864a8.svg";